import React, { useState } from "react";
import { graphql, Query } from "react-apollo";
import { notify } from "../generic";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlugCirclePlus,
  faCheckCircle,
  faWarning,
  faSpinner
} from "@fortawesome/free-solid-svg-icons";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../Context";

import { createCompte } from "../../api/queries/comptes.mutations";
import { validate } from "../../api/queries/utilisateur.mutations";

export function AddAccountButton(props) {
  const authContext = useAuthState(); //read user de
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [addAccountUrl, setAddAccountUrl] = useState("");

  const { userDetails = {} } = authContext;
  const { id: utilisateurId, login, email, token } = userDetails;

  if (!utilisateurId) return;

  const renderModal = () => {
    if (!visibleModal) return null;

    return (
      <div>
        <Modal open={visibleModal} onClose={() => setVisibleModal(false)}>
          <h2>
            {" "}
            <FontAwesomeIcon size="lg" icon={faPlugCirclePlus} /> Ajouter un
            compte
          </h2>
          <p>
            Vous allez être redirigé vers notre partenaire bancaire afin
            d'ajouter un compte bancaire à votre espace Penge. Cette procédure
            est sécurisée.
          </p>
          <p>
            Une fois ce processus validé, vous serez redirigé sur l'application.
          </p>
          <p>
            {" "}
            <FontAwesomeIcon icon={faWarning} size="sm" />
            &nbsp; Munissez-vous de votre téléphone, votre banque vous
            demandera, la plupart du temps, d'authentifier votre demande.
          </p>
          <Row>
            <Col xs={12}>
              <a
                className={`btn btn-cta right ${loading ? "loading" : ""}`}
                onClick={() =>
                  !loading ? (window.location = addAccountUrl) : null
                }
              >
                <FontAwesomeIcon size="lg" icon={faCheckCircle} />
                &nbsp; Continuer
                <div className="btn-cta-overlay"></div>{" "}
              </a>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  };

  const _mutateCreateAccount = async () => {
    try {
      setLoading(true);
      setVisibleModal(true);

      // Si on a déjà l'url on ne recharge pas, ça évite de se faire temp ban par bridge
      if (addAccountUrl) {
        setLoading(false);
        return;
      }

      return props
        .createCompte({
          variables: {
            utilisateurId
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.createCompte;
          const { url } = JSON.parse(details);

          if (type === "success") {
            setAddAccountUrl(url);
          } else {
            notify("error", message);
          }
        })
        .finally(() => setLoading(false));
    } catch (error) {
      notify("error", error.message);
    }
  };

  return (
    <>
      <a
        className={`btn btn-cta ${loading ? "speedy" : ""}`}
        onClick={() => _mutateCreateAccount()}
      >
        <FontAwesomeIcon
          size="lg"
          spin={loading}
          icon={loading ? faSpinner : faPlugCirclePlus}
        />
        &nbsp; Ajouter un compte <div className="btn-cta-overlay"></div>
      </a>
      {renderModal()}
    </>
  );
}

export default graphql(createCompte, {
  name: "createCompte"
})(AddAccountButton);
